/**
 * Returns the i18n namespace for meta translations based on the active theme.
 * - gisy  → 'meta'
 * - juppen → 'metaJuppen'
 * - prange → 'metaPrange'
 */
export function useThemeMeta() {
    const { public: { theme } } = useRuntimeConfig()

    const metaKey = theme === 'gisy'
        ? 'meta'
        : `meta${theme.charAt(0).toUpperCase()}${theme.slice(1)}`

    return { metaKey }
}